import React from 'react';
import { Spin } from 'antd';


const PageLoader: React.FC = () => {
    
    return <Spin fullscreen style={{color:"black"}} tip="Loading..." size="large" />;
};

export default PageLoader;